/**
 * This function submits shipping estimation request form data to the app for processing
 */
function submitShippingEstimationRequest() {
  $(".div_row_freight_estimation_results").removeClass("show");
  $(".div_freight_estimation_results table tbody").html("");
  var validationResult = validateRequiredFormInputs();

  if (!validationResult) {
    console.log('validationResult', validationResult);
    return false;
  }

  var formData = new FormData();
  formData.append('zip', $("input[name=zip_shipping_estimate]").val());
  formData.append('quantity', $("input[name=quantity_shipping_estimate]").val());
  formData.append('id', $("input[name=product_id]").val());
  console.log('Shipping Estimate Data', formData);

  $(".div_row_spinner_freight_estimate").toggleClass("show");
  $.ajax({
    type: 'POST',
    url: document.location.origin + '/a/data/shipping-rate-quotes',
    data: formData,
    contentType: false,
    processData: false,
    cache: false,
    success: function(data) {
      $(".div_row_spinner_freight_estimate").toggleClass("show");

      console.log('this.app_obj', this.app_obj);
      if (data.success && data.data.length > 0) {
        $(".div_row_freight_estimation_results").addClass("show");
        fillTheEstimateTable(data.data);
      } else {
        $(".div_row_freight_estimation_results").removeClass("show");
        // openSnackbar("Registration failed" + (data.message) ? data.message : ". No message returned from server.");
      }
    },
    error: function(data) {
      $(".div_row_freight_estimation_results").toggleClass("show");
      // openSnackbar("Error submitting form. Please try again." + JSON.stringify(data));
      console.log("submit-freight data error", data);
    },
    dataType: 'json'
  });

  console.log('Shipping Estimation Call completed');
}

/**
* Validate required form fields in freight estimation form
*/
function validateRequiredFormInputs() {
  console.log('validateRequiredFormInputs $(".missing_data")', $(".missing_data").length, $(".missing_data"));

  $(".missing_data").each(function() {
    $(this).removeClass("missing_data");
    console.log('removing  missing_data', $(this));
  })

  var zip = $("input[name=zip_shipping_estimate]").val();
  console.log('zip', zip);

  if (!/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)) {
    $("input[name=zip_shipping_estimate]").addClass("missing_data");
  }

  var quantity = $("input[name=quantity_shipping_estimate]").val();
  console.log('quantity', quantity);

  if (!/^\d+$/.test(quantity)) {
    $("input[name=quantity_shipping_estimate]").addClass("missing_data");
  }

  var validForm = $(".missing_data").length == 0;
  console.log('validForm', validForm);

  if (!validForm) {
    $(".div_missing_data_in_fields").addClass("shown");
  } else {
    $(".div_missing_data_in_fields").removeClass("shown")
  }

  return validForm;
}

/**
 * Fill the estimate table with the data from the app
 *
 * @param data
 */
function fillTheEstimateTable(data) {
  $(".div_freight_estimation_results table tbody").html("");

  data.forEach(function (element) {
    var row = "<tr>";
    row += "<td className=\"td_shipping_estimate_carrier\">" + element.shipper + "</td>";
    row += "<td className=\"td_shipping_estimate_type\">" + element.service_name + "</td>";
    row += "<td className=\"td_shipping_estimate_quote\" style=\"text-align: right;\">$" + element.formatted_total_charge + "</td>";
    row += "</tr>";
    $(".div_freight_estimation_results table tbody").append(row);
  });
}
